















import {
  DynamicDocumentItem,
  DynamicDocumentItemData,
  InstallationModule,
  InstallationModuleData,
  MechanicInstallation,
} from '@/types';
import Vue, { PropType, VueConstructor } from 'vue';

import {
  Custom,
  Image,
  NumberInput,
  Signature,
  Text,
  Header,
  YesNo,
  HighLow,
  DateInput,
  MultipleChoice,
  Value,
  Warning,
  SerialNumberInput,
} from './renderers';

export default Vue.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    data: Object as PropType<DynamicDocumentItemData>,
    // Every answer in the document, so a renderer can resolve a cross-field `required` condition.
    // Absent, each renderer falls back to its own row — which is what they all did before, and what
    // made every conditional requirement read false.
    documentData: Array as PropType<DynamicDocumentItemData[]>,
    moduleData: Object as PropType<InstallationModuleData>,
    module: Object as PropType<InstallationModule>,
    installation: Object as PropType<MechanicInstallation>,
    isActive: Boolean,
    isOpen: Boolean,
  },

  computed: {
    renderer(): VueConstructor | undefined {
      switch (this.item.type) {
        case 'CUSTOM':
          return Custom;
        case 'IMAGE':
          return Image;
        case 'SIGNATURE':
          return Signature;
        case 'TEXT':
          return Text;
        case 'HEADER':
          return Header;
        case 'BOOL':
          return YesNo;
        case 'HIGH-LOW':
          return HighLow;
        case 'NUMBER':
          return NumberInput;
        case 'VALUE':
        case 'EMAIL':
          return Value;
        case 'MULTIPLE_CHOICE':
          return MultipleChoice;
        case 'SERIAL':
          return SerialNumberInput;
        case 'WARNING':
          return Warning;
        case 'DATE':
          return DateInput;
        default:
          return undefined;
      }
    },
  },
});
